import axios from 'axios'
import store from '@/globalvar.js'
import router from '@/router'

// Esto puedo necesitarlo cuando implemente el login
// import { StorageService } from '../services/storage.service'

import StorageService from '@/services/storage.service'

//let timeout = null;
let pendingRequests = 0;
let failSafe = null;

function getFailSafeTime() {  
  return window.APP_CONFIG?.loaderFailSafeMs || 30000;
}
/*
function formatDateForApi(date, type = 'date') {
  const pad = n => n.toString().padStart(2, '0');

  const y = date.getFullYear();
  const m = pad(date.getMonth() + 1);
  const d = pad(date.getDate());
  const h = pad(date.getHours());
  const min = pad(date.getMinutes());
  const s = pad(date.getSeconds());

  if (type === 'datetime') {
    return `${y}-${m}-${d} ${h}:${min}:${s}`;
  }

  return `${y}-${m}-${d}`;
}*/
/*function formatDateForApi(date, type = 'date') {
  if (!date) return null;

  const pad = n => n.toString().padStart(2, '0');

  const y = date.getFullYear();
  const m = pad(date.getMonth() + 1);
  const d = pad(date.getDate());

  if (type === 'date') {
    // 👇 SOLO fecha (sin timezone)
    return `${y}-${m}-${d}`;
  }

  if (type === 'datetime') {
    // 👇 usar UTC real (evita desfases)
    return date.toISOString().replace('T', ' ').split('.')[0];
    // ejemplo: "2026-03-01 03:00:00"
  }

  return null;
}*/

function startLoading() {
      pendingRequests++
      store.commit('SET_LOADING', true);
       if (!failSafe) {
          failSafe = setTimeout(() => {
            pendingRequests = 0;
            store.commit('SET_LOADING', false);
            failSafe = null;
          }, getFailSafeTime())
        }
    }
   function endLoading() {
      if (pendingRequests > 0) pendingRequests--;

      if (pendingRequests === 0) {
        store.commit('SET_LOADING', false);

        if (failSafe) {
          clearTimeout(failSafe);
          failSafe = null;
        }
      }
    }

   function ResetLoading(){     
      pendingRequests = 0;
      store.commit('SET_LOADING', false);

      if (failSafe) {
        clearTimeout(failSafe);
        failSafe = null;
      }
    }

const ApiService = {
  APIURL: '', 
  init(baseURL) {
    this.APIURL = baseURL
    axios.defaults.baseURL = baseURL;
    store.commit('setApiUrl',baseURL);    
    
    axios.interceptors.request.use(config => {
      if (!config.DisableLoading) {
        startLoading();
      }
      var token = StorageService.getOnlyToken();
      if (token) {
          config.headers.Authorization = `Bearer ${token}`;
      }  
      const routeName = window?.appVueRouter?.currentRoute?.value?.name || (window.location.pathname);
      if (routeName) {
        config.headers['X-View-Name'] = routeName;
      }      
      return config;
    },
      error => {
        endLoading()
        return Promise.reject(error)
      }
  );
  


   axios.interceptors.response.use(response => {
    endLoading();
      return response;
    }, error => {
      endLoading();
      if(error.response && 401 === error.response.status) {        
        if (error.response.data && error.response.data.errorMessage == "Select Provider") {
          ResetLoading(); 
          router.push('/provider');              
        } else {
          var uname = StorageService.getName();
          if ( uname == null ) {
            uname = "user";
          }
          ResetLoading();          
            store.commit('unauthorized', true);
            if (router.currentRoute.path !== '/unauthorized') {
              router.replace('/unauthorized');
            }
          store.commit('setAccessToken','');
          localStorage.removeItem("vuex");
          localStorage.removeItem("_secure__ls__metadata");                         
        }        
        return error.response.statusText;
      }    
      return Promise.reject(error);          
    });
  },

 

    setHeader() {

    },

    removeHeader() {
        axios.defaults.headers.common = {}
    },

    get(resource) { 
        return axios.get(resource,{
            headers: {}
          })
    },

    getData(resource, data) { 
        return axios.get(resource, data)
    },

    post(resource, data, config = {}) {
        return axios.post(resource,data,{
          ...config,
          headers: {}
        })
    },

    put(resource, data) {
        return axios.put(resource, data,{
          headers: {}
        })
    },

    delete(resource, data) {
        return axios.delete(resource, { data: data },{
            headers: {}
          })
    },

      /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
    **/
    /*customRequest(data) {
      let params = data.params;
        if(params) {
           params = { ...params }; // 👈 CLAVE: CLONAR ACÁ
          Object.keys(params).forEach(key => {
            let value = params[key];
            if (value instanceof Date) {
              const isOnlyDate =
                value.getHours() === 0 &&
                value.getMinutes() === 0 &&
                value.getSeconds() === 0;

              params[key] = formatDateForApi(
                value,
                isOnlyDate ? 'date' : 'datetime'
              );

               params[key] = isOnlyDate
          ? `${value.getFullYear()}-${(value.getMonth()+1).toString().padStart(2,'0')}-${value.getDate().toString().padStart(2,'0')}` // solo fecha
          : `${value.getFullYear()}-${(value.getMonth()+1).toString().padStart(2,'0')}-${value.getDate().toString().padStart(2,'0')} ${value.getHours().toString().padStart(2,'0')}:${value.getMinutes().toString().padStart(2,'0')}:${value.getSeconds().toString().padStart(2,'0')}`; // datetime

            }


          })
        }
        var result = axios(data);
        return result;
    },*/

    customRequest(data) {
  // clonamos params
  let params = data.params ? { ...data.params } : {};

  Object.keys(params).forEach(key => {
    const value = params[key];
    if (value instanceof Date) {
      const isOnlyDate =
        value.getHours() === 0 &&
        value.getMinutes() === 0 &&
        value.getSeconds() === 0;

      if (isOnlyDate) {
        // solo fecha: YYYY-MM-DD
        const y = value.getFullYear();
        const m = (value.getMonth() + 1).toString().padStart(2, '0');
        const d = value.getDate().toString().padStart(2, '0');
        params[key] = `${y}-${m}-${d}`;
      } else {
        // datetime: YYYY-MM-DD HH:mm:ss (hora local)
        const y = value.getFullYear();
        const m = (value.getMonth() + 1).toString().padStart(2, '0');
        const d = value.getDate().toString().padStart(2, '0');
        const h = value.getHours().toString().padStart(2, '0');
        const min = value.getMinutes().toString().padStart(2, '0');
        const s = value.getSeconds().toString().padStart(2, '0');
        params[key] = `${y}-${m}-${d} ${h}:${min}:${s}`;
      }
    }
  });

  // enviamos el clon ya convertido a string
  return axios({
    ...data,
    params
  });
},

    /*parseParams(params) {
      const keys = Object.keys(params)
      let options = ''
    
      keys.forEach((key) => {
        const isParamTypeObject = typeof params[key] === 'object'
        const isParamTypeArray = isParamTypeObject && params[key] && params[key].length >= 0
    
        if (!isParamTypeObject) {
          options += `${key}=${params[key]}&`
        }
    
        if (isParamTypeObject && isParamTypeArray) {
          params[key].forEach((element) => {
            options += `${key}=${element}&`
          })
        }
      })    
      return options ? options.slice(0, -1) : options
    },*/


    /*parseParams(params) {
  const keys = Object.keys(params)
  let options = ''

  keys.forEach((key) => {
    const value = params[key]

    if (Array.isArray(value)) {
      value.forEach((element) => {
        options += `${key}=${element}&`
      })
    } else if (value !== null && value !== undefined) {
      options += `${key}=${value}&`
    }
  })

  return options ? options.slice(0, -1) : options
},*/


// La que estaba antes
/*parseParams(params) {
  const keys = Object.keys(params)
  let options = ''

  keys.forEach((key) => {
    let value = params[key]

    if (Array.isArray(value)) {
      value.forEach((element) => {
        options += `${key}=${element}&`
      })
    } 
    else if (value instanceof Date) {
     // options += `${key}=${value.toISOString()}&`
     options += `${key}=${formatLocal(value)}&`
    } 
    else if (value !== null && value !== undefined) {
      options += `${key}=${value}&`
    }
  })

  return options ? options.slice(0, -1) : options
},*/

parseParams(params) {
  const keys = Object.keys(params)
  let options = ''

  const pad = n => n.toString().padStart(2, '0')

  const formatSmart = (date) => {
    const hasTime =
      date.getHours() !== 0 ||
      date.getMinutes() !== 0 ||
      date.getSeconds() !== 0

    const datePart = `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())}`

    if (!hasTime) {
      return datePart
    }

    const timePart = `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`

    return `${datePart}T${timePart}`
  }

  keys.forEach((key) => {
    let value = params[key]

    if (Array.isArray(value)) {
      value.forEach((element) => {
        if (element instanceof Date) {
          options += `${key}=${formatSmart(element)}&`
        } else {
          options += `${key}=${element}&`
        }
      })
    } 
    else if (value instanceof Date) {
      options += `${key}=${formatSmart(value)}&`
    } 
    else if (value !== null && value !== undefined) {
      options += `${key}=${value}&`
    }
  })

  return options ? options.slice(0, -1) : options
},

    getWithArray(resource,data) {     
      return axios.get(resource, {
        params: data,
          paramsSerializer: (params) => this.parseParams(params)
        }
      )
    },
}

export default ApiService